module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/swiss_day-93bbb72e1b0757dac91ea35eeaebf442.svg";